// @flow

import type { Action } from 'app/common/redux/types';

export type State = {
  repinAnimation: {
    startAnimation: boolean,
    pinId: ?string,
  },
};

const initialState = {
  repinAnimation: {
    startAnimation: false,
    pinId: null,
  },
};

const header = (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case 'SHOW_REPIN_ANIMATION':
      return {
        ...state,
        repinAnimation: {
          startAnimation: true,
          pinId: action.payload.pinId,
        },
      };
    case 'HIDE_REPIN_ANIMATION':
      return {
        ...state,
        repinAnimation: {
          startAnimation: false,
          pinId: null,
        },
      };
    default:
      return state;
  }
};

export default header;
